export default __webpack_public_path__ + "static/media/edit.725b791f.svg";